// Catálogo dos cards do Dashboard que o usuário pode ligar/desligar em
// Configurações > Dashboard. `padrao` é o estado de quem nunca personalizou.

export const DASHBOARD_GROUPS = [
  {
    id: 'essenciais',
    titulo: 'Essenciais',
    publico: 'Pessoa física e empresa',
    desc: 'Os quatro cards de atalho que aparecem para todo mundo. Cada um leva direto para a tela correspondente.',
  },
  {
    id: 'empresarial',
    titulo: 'Indicadores empresariais',
    publico: 'Recomendado para empresas (PJ)',
    desc: 'Indicadores de contabilidade e gestão. Fazem mais sentido para quem precisa acompanhar o resultado de um negócio — para uso pessoal costumam ser desnecessários.',
  },
  {
    id: 'analises',
    titulo: 'Gráficos e listas',
    publico: 'Pessoa física e empresa',
    desc: 'Blocos de análise que ajudam a entender para onde o dinheiro está indo.',
  },
  {
    id: 'menu',
    titulo: 'Menu lateral',
    publico: 'Recomendado para empresas (PJ)',
    desc: 'Telas extras que só aparecem no menu se você ativar. Quem não precisa delas mantém o menu mais limpo.',
  },
];

export const DASHBOARD_CARDS = [
  // ── Essenciais
  { id: 'saldo', group: 'essenciais', padrao: true, label: 'Saldo atual', desc: 'Soma do saldo de todas as suas contas e carteiras. Clique para abrir Carteira.' },
  { id: 'receitas', group: 'essenciais', padrao: true, label: 'Receitas', desc: 'Total de entradas do período. Clique para ver os lançamentos de receita.' },
  { id: 'despesas', group: 'essenciais', padrao: true, label: 'Despesas', desc: 'Total de saídas do período. Clique para ver os lançamentos de despesa.' },
  { id: 'cartao', group: 'essenciais', padrao: true, label: 'Cartão de crédito', desc: 'Quanto do limite dos seus cartões está comprometido com faturas em aberto. Clique para abrir Cartões.' },

  // ── Empresarial
  { id: 'faturamento_bruto', group: 'empresarial', padrao: false, label: 'Faturamento bruto', desc: 'Tudo que a empresa vendeu/recebeu no período, antes de descontar custos e despesas.' },
  { id: 'lucro_bruto', group: 'empresarial', padrao: false, label: 'Lucro bruto', desc: 'Faturamento menos custos e despesas: quanto realmente sobrou no período.' },
  { id: 'margem_bruta', group: 'empresarial', padrao: false, label: 'Margem bruta', desc: 'Percentual do faturamento que virou lucro. Ajuda a comparar meses com volumes diferentes.' },
  { id: 'ebitda', group: 'empresarial', padrao: false, label: 'EBITDA', desc: 'Resultado operacional: receitas menos custos e despesas fixas e variáveis (sem despesas não operacionais). Muito usado em análises contábeis.' },
  { id: 'custos', group: 'empresarial', padrao: false, label: 'Custos totais', desc: 'Gastos diretamente ligados a produzir ou entregar o que a empresa vende (matéria-prima, mão de obra direta etc.).' },
  { id: 'despesas_fixas', group: 'empresarial', padrao: false, label: 'Despesas fixas', desc: 'Gastos que se repetem todo mês independente das vendas: aluguel, salários, assinaturas.' },
  { id: 'despesas_variaveis', group: 'empresarial', padrao: false, label: 'Despesas variáveis', desc: 'Gastos que mudam conforme a operação: marketing, utilidades, comissões.' },
  { id: 'despesas_nao_op', group: 'empresarial', padrao: false, label: 'Despesas não operacionais', desc: 'Gastos fora da atividade principal, como juros e multas.' },

  // ── Gráficos e listas
  { id: 'filtro_contas', group: 'analises', padrao: true, label: 'Filtro por conta', desc: 'Botões no topo para ver o dashboard de uma conta específica.' },
  { id: 'evolucao', group: 'analises', padrao: true, label: 'Evolução ao longo do tempo', desc: 'Gráfico mensal de receitas, custos ou despesas.' },
  { id: 'distribuicao', group: 'analises', padrao: true, label: 'Distribuição financeira', desc: 'Gráfico de pizza com a proporção entre receitas, custos e despesas.' },
  { id: 'recentes', group: 'analises', padrao: true, label: 'Lançamentos recentes', desc: 'Lista dos últimos lançamentos registrados.' },

  // ── Menu lateral
  { id: 'menu_fluxo_caixa', group: 'menu', padrao: false, label: 'Fluxo de Caixa', desc: 'Mostra a tela de Fluxo de Caixa no menu: projeção de entradas e saídas ao longo do tempo, útil para planejar o caixa de uma empresa.' },
];

// Itens de menu (não são cards do dashboard)
export const isMenuItem = (id) => id.startsWith('menu_');

export const defaultDashboardCards = () =>
  Object.fromEntries(DASHBOARD_CARDS.map(c => [c.id, c.padrao]));

// Mescla o que o usuário salvou com os padrões (cards novos entram no padrão).
export const resolveDashboardCards = (user) => ({
  ...defaultDashboardCards(),
  ...(user?.preferencias?.dashboardCards || {}),
});

export const PRESETS = {
  pessoal: { label: 'Perfil pessoal', desc: 'Só o essencial e os gráficos', build: () => defaultDashboardCards() },
  empresarial: {
    label: 'Perfil empresarial',
    desc: 'Tudo ligado, com indicadores contábeis',
    build: () => Object.fromEntries(DASHBOARD_CARDS.map(c => [c.id, true])),
  },
};
